import React, { useState, useRef, useEffect } from "react";
import { Grid, TextField, InputLabel, MenuItem, makeStyles } from '@material-ui/core';
import NumberFormat from "react-number-format";
import i18next from "i18next";
import LightTooltip from "../../LightTooltip";
import { getNumberFormats } from "../../../Utilities/Functions";
import styles from "../styles";

const useStyles = makeStyles(styles);

const NumberField = (props) => {
  const {
    id,
    label,
    labelIcon,
    name,
    placeholder,
    required,
    initialValue,
    initialUnitValue,
    units,
    disabled,
    onValueChange,
    onUnitCHange,
    decimalScale,
    minValue,
    maxValue,
    step,
  } = props;

  useEffect(() => {
    setFormats(getNumberFormats());
  }, [i18next.language]);

  useEffect(() => {
    setValue(initialValue || "");
    setFormats(getNumberFormats());
  }, [initialValue]);

  const [value, setValue] = useState(initialValue || "");
  const [formattedValue, setFormattedValue] = useState(initialValue || "");
  const [formats, setFormats] = useState({});
  const [unitValue, setUnitValue] = useState(initialUnitValue || "");
  const [isOverflowed, setIsOverflow] = useState(initialValue && initialValue.length > 0);

  const textElementRef = useRef({});
  const classes = useStyles();

  const checkOverFlow = (e) => {
    if (!value) {
      setIsOverflow(false);
    } else if (textElementRef.current && value) {
      setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
    }
  };

  const handleValueChange = (values) => {
    setValue(values.value);
    setFormattedValue(values.formattedValue);
    if (parseFloat(value) === values.floatValue) {
      return;
    }
    if (onValueChange !== undefined && typeof onValueChange === "function") {
      onValueChange(values.value);
    }
  };

  const handleUnitChange = (e) => {
    setUnitValue(e.target.value);
    if (onUnitCHange !== undefined && typeof onUnitCHange === "function") {
      onUnitCHange(e.target.value);
    }
  };

  return (
    <>
      <InputLabel className={classes.inputLabel}>
        {label}
        {required && (
          <span
            aria-hidden="true"
            className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
            style={{ color: "#E30613" }}
          >
            &thinsp;*
          </span>
        )}
        {labelIcon}
      </InputLabel>
      <LightTooltip
        title={<span>{formattedValue}</span>}
        placement="top-start"
        disableFocusListener
        disableHoverListener={!isOverflowed}
        style={{ paddingBottom: 0, paddingTop: 0 }}
      >
        <Grid container spacing={0} >
          {units && units.length > 0 && <Grid item md={4}>
            <TextField
              select
              size="small"
              margin="dense"
              variant="outlined"
              className={classes.inputField}
              value={unitValue}
              onChange={handleUnitChange}
            >
              {units.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>}
          <Grid item md={units && units.length > 0 ? 8 : 12}>
            <NumberFormat
              name={name}
              id={id}
              size="small"
              margin="dense"
              variant="outlined"
              placeholder={placeholder}
              className={classes.inputField}
              onBlur={checkOverFlow}
              value={value}
              disabled={disabled}
              required={required}
              fullWidth
              decimalScale={decimalScale ? decimalScale : 2}
              allowNegative={minValue === 0}
              decimalSeparator={formats.decimalSeparator}
              thousandSeparator={formats.thousandSeparator}
              thousandsGroupStyle={formats.thousandsGroupStyle}
              onValueChange={handleValueChange}
              customInput={TextField}
              inputProps={
                {
                  style: {
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                  }
                }
              }
            />
          </Grid></Grid>
      </LightTooltip>
    </>
  );
};

export default NumberField;
